module.exports = __webpack_public_path__ + "static/media/3.6ca9a2fa.png";